import React, { useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { BREAKPOINTS, COLORS } from '../../ui/variables';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const Container = styled.ul`
  list-style: none;
  width: 100%;
  margin: 0;

  span {
    &:hover {
      color: ${COLORS.HOVER_BLACK};
    }

    @media ${BREAKPOINTS.MOBILE} {
      &:focus {
        color: ${COLORS.HOVER_BLACK};
      }
    }
  }
`;

const Wrapper = styled.div`
  border-top: 1px solid ${COLORS.BLACK};
  margin-top: 45px;
  padding-top: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface StyleProps {
  font: string;
}

const Value = styled.span<StyleProps>`
  font-family: ${props => props.font};
  font-size: ${props => (props.font === 'Adonis' ? '52px' : '28px')};
  font-weight: ${props => (props.font === 'Adonis' ? '400' : '600')};
  line-height: 48px;
  letter-spacing: ${props => (props.font === 'Adonis' ? '-1.5px' : '0px')};
  width: 100%;
  @media ${BREAKPOINTS.TABLET} {
    font-size: ${props => (props.font === 'Adonis' ? '32px' : '24px')};
    line-height: 35px;
    letter-spacing: ${props => (props.font === 'Adonis' ? '-1px' : '0px')};
  }
  @media screen and (max-width: 500px) {
    width: 290px;
  }
`;

const Explanation = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? 'block' : 'none')};
  font-size: 24px;
  line-height: 33px;
  letter-spacing: -0.3px;
  margin-top: 24px;
  margin-bottom: 48px;
  @media ${BREAKPOINTS.MOBILE} {
    font-size: 20px;
    line-height: 26px;
  }
`;

interface Values {
  id: string;
  value: string;
  description: any;
}

interface Props {
  initialState: 0 | null;
  borderColor?: 'white' | 'black';
  font?: string;
  faq: Values[];
}

const Accordion = ({ initialState, borderColor, font, faq }: Props) => {
  const [display, setDisplay] = useState<number | null>(initialState);

  const toggleValue = (index: number) => {
    if (display === index) {
      setDisplay(null);
      return;
    }
    setDisplay(index);
  };

  return (
    <Container>
      {faq.map((item, index) => (
        <li key={item.id}>
          <Wrapper
            onClick={() => toggleValue(index)}
            css={css`
              border-top: 1px solid
                ${borderColor === 'white' ? COLORS.WHITE : COLORS.BLACK};
            `}
          >
            <Value font={font}>{item.value}</Value>
            {display === index ? (
              <KeyboardArrowUpIcon
                style={{
                  color: `${borderColor === 'white' ? 'white' : 'black'}`,
                }}
              />
            ) : (
              <KeyboardArrowDownIcon
                style={{
                  color: `${borderColor === 'white' ? 'white' : 'black'}`,
                }}
              />
            )}
          </Wrapper>
          <Explanation active={display === index}>
            {item.description}
          </Explanation>
        </li>
      ))}
    </Container>
  );
};

export default Accordion;
